/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RansomwareProxyDeactivationSpec { 
    /**
     * Org id
     */
    org_id: string;
    /**
     * Carbon Black PoP ID
     */
    cb_pop_id: string;
    /**
     * Org Key
     */
    org_key: string;
}

